export default __webpack_public_path__ + "static/media/sonarqubecloud.bf0fae8a.svg";